import { Controller } from "@hotwired/stimulus"
import { isTime, iso8601Parse } from "../lib/date_helpers"
import { MetaVars } from "../lib/helpers"
const strftime = require('strftime')

export default class extends Controller {
  static values = {
    time: String
  }

  connect() {
    this.transform()

    // A morph rewrites this element's text to the server-rendered date without
    // reconnecting the controller — re-apply the client format. Page refreshes
    // fire turbo:morph; frame/stream morphs only fire turbo:morph-element, and
    // we listen for that on the element itself so one morph doesn't re-run
    // every date controller on the page.
    this.morphHandler = () => this.transform()
    this.element.addEventListener("turbo:morph-element", this.morphHandler)
    document.addEventListener("turbo:morph", this.morphHandler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:morph-element", this.morphHandler)
    document.removeEventListener("turbo:morph", this.morphHandler)
  }

  // Fires when a morph (or anything else) changes the time value attribute.
  timeValueChanged() {
    this.transform()
  }

  transform() {
    this.element.textContent = strftime(this.format, this.transformedTime)
  }

  get format() {
    if (isTime(this.timeValue)) return MetaVars.timeFormatString

    return MetaVars.dateFormatString
  }

  get transformedTime() {
    if (isTime(this.timeValue)) return new Date(this.timeValue)

    // Correct date timezone offset parsing bug.
    // Use the local timezone offset and add it to the existing date to ensure date isn't off by one day.
    return iso8601Parse(this.timeValue)
  }
}
